import clsx from 'clsx';
import DOMPurify from 'dompurify';
import InnerHTMLDiv from '../common/inner-html-div.component';
import { useScreenSize } from '../common-hooks';
import { DomElementAlignment, DomTargetPosition } from '../enums';
import Tooltip from '../tooltip-component/tooltip.component';

const createMarkup = (value: string) => {
  return DOMPurify.sanitize(value, { USE_PROFILES: { html: true } });
};

interface HelpDescriptionProps {
  description: string;
}

const HelpDescription = ({ description }: HelpDescriptionProps) => {
  return <InnerHTMLDiv html={createMarkup(description)} />;
};

export interface HelpComponentProps {
  description: string;
  className?: string;
  tooltipZIndexCheck?: boolean;
  tooltipAlignment?: DomElementAlignment;
  tooltipTargetPosition?: DomTargetPosition;
}

export default function HelpComponent({
  description,
  tooltipZIndexCheck = false,
  tooltipAlignment = DomElementAlignment.TopRight,
  tooltipTargetPosition = DomTargetPosition.Left,
  className,
}: HelpComponentProps) {
  const { isMobile } = useScreenSize();
  const _wrapperClassName = clsx('cursor-default', className);

  return (
    <Tooltip
      tooltipAlignment={tooltipAlignment}
      tooltipTargetPosition={tooltipTargetPosition}
      description={<HelpDescription description={description} />}
      wrapperClassName={_wrapperClassName}
      tooltipClassName="-mt-1 bg-mono-1 max-w-sm odin help-links"
      dependOnChildren={true}
      exitDebounceTime={150}
      tooltipZIndexCheck={tooltipZIndexCheck}
      shouldUseCreatePortal={isMobile}
      enableMobileTouch={true}
    >
      <div className="h-4 w-4 rounded-full bg-info text-center text-xs font-bold text-mono-1">?</div>
    </Tooltip>
  );
}
